import React from 'react';
const CrumbButton = _ref => {
  let {
    linkName,
    clickAction = () => {}
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    style: {
      cursor: 'pointer',
      color: '#0078B9'
    },
    onClick: () => clickAction()
  }, linkName));
};
export default CrumbButton;